import { Link } from "react-router-dom";
import { LogoMark } from "@/components/Logo";
import { Reveal } from "@/components/Reveal";
import { SmsSignup } from "@/components/SmsSignup";

const SOCIALS = [
  { label: "Instagram", href: "https://www.instagram.com/sviinbrand?utm_source=ig_web_button_share_sheet&exln=ZDNlZDc0MzIxNw==" },
];

export const Footer = () => (
  <footer data-testid="main-footer" className="relative overflow-hidden bg-[#111111] text-[#F4F2EE]">
    <div className="mx-auto max-w-[1600px] px-4 pt-20 md:px-8 md:pt-28">
      <div className="grid gap-16 md:grid-cols-12">
        <Reveal className="md:col-span-7">
          <p className="label text-[#F4F2EE]/65">Text club</p>
          <h2 className="mt-4 text-4xl font-bold leading-[0.95] tracking-[-0.05em] sm:text-5xl lg:text-6xl">Get first access<br />to drops.</h2>
          <p className="label mt-8 text-[#F4F2EE]/65">Get 10% off your first order by text</p>
          <div className="mt-2"><SmsSignup source="footer" dark /></div>
        </Reveal>
        <div className="grid grid-cols-2 gap-8 md:col-span-4 md:col-start-9">
          <div>
            <p className="label text-[#F4F2EE]/65">Shop</p>
            <ul className="mt-5 space-y-3 text-sm">
              <li><Link to="/shop" className="draw-link" data-testid="footer-link-shop">All products</Link></li>
              <li><Link to="/about" className="draw-link" data-testid="footer-link-about">About</Link></li>
            </ul>
          </div>
          <div>
            <p className="label text-[#F4F2EE]/65">Follow</p>
            <ul className="mt-5 space-y-3 text-sm">
              {SOCIALS.map((s) => (
                <li key={s.label}><a href={s.href} target="_blank" rel="noopener noreferrer" className="draw-link" data-testid={`footer-social-${s.label.toLowerCase()}`}>{s.label}</a></li>
              ))}
            </ul>
          </div>
        </div>
      </div>
      <div className="mt-20 flex flex-wrap items-center justify-between gap-4 border-t border-[#F4F2EE]/15 py-6">
        <div className="flex items-center gap-3">
          <span className="ring-1 ring-[#F4F2EE]/20"><LogoMark className="h-6 w-6" /></span>
          <p className="label text-[10px] text-[#F4F2EE]/65">© {new Date().getFullYear()} <span className="normal-case">Sviin</span></p>
        </div>
      </div>
    </div>
    <div aria-hidden="true" className="pointer-events-none select-none overflow-hidden text-center font-['Pinyon_Script',cursive] text-[30vw] leading-[1.1] -mb-[6vw] text-[#F4F2EE]/[0.08]">
      Sviin
    </div>
  </footer>
);
